import { ReactComponent as OakLogo } from '../../assets/logos/oak.svg'

const columns = [
  {
    heading: 'Product',
    links: [
      { label: 'Status', href: '/status' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About Us', href: '/about' },
      { label: 'Press', href: '/press' },
      { label: 'Contact', href: '/contact' },
    ],
  },
]

const mobileLinks = [
  { label: 'About Us', href: '/about' },
  { label: 'Status', href: '/status' },
  { label: 'Press', href: '/press' },
  { label: 'Contact', href: '/contact' },
]

export default function Footer() {
  return (
    <footer className="rounded-section bg-oak-yellow px-6 pb-10 pt-16 md:pb-16 md:pt-24">
      <div className="mx-auto max-w-content">
        <div className="grid grid-cols-1 gap-12 pb-16 md:grid-cols-12 md:gap-8 md:pb-24">
          <div className="md:col-span-5">
            <p className="max-w-[400px] text-[clamp(16px,1.8vw,20px)] font-medium leading-[1.5] tracking-[-0.3px] text-oak-black">
              Oak helps licensors grow their brand communities — reaching their members across third party platforms, marketplaces, and social tools.
            </p>
          </div>

          <div className="md:col-span-7">
            <div className="md:hidden">
              <h4 className="text-[13px] font-semibold uppercase tracking-[0.08em] text-oak-black/40">
                Company
              </h4>
              <ul className="mt-4 grid grid-cols-2 gap-x-8 gap-y-3">
                {mobileLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-[15px] font-medium tracking-[-0.3px] text-oak-black transition-opacity hover:opacity-60"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="hidden grid-cols-2 gap-8 sm:grid-cols-3 md:grid md:gap-6">
              {columns.map((col) => (
                <div key={col.heading}>
                  <h4 className="text-[13px] font-semibold uppercase tracking-[0.08em] text-oak-black/40">
                    {col.heading}
                  </h4>
                  <ul className="mt-4 space-y-3">
                    {col.links.map((link) => (
                      <li key={link.label}>
                        <a
                          href={link.href}
                          className="text-[15px] font-medium tracking-[-0.3px] text-oak-black transition-opacity hover:opacity-60"
                        >
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end md:gap-6">
          <div>
            <OakLogo className="h-6 w-auto text-black md:h-8" />
            <p className="mt-5 text-[13px] font-medium tracking-[-0.45px] text-black md:mt-2 md:text-[15px]">
              Copyright &copy; {new Date().getFullYear()} Oak Platforms Inc.
            </p>
          </div>
          <div className="flex gap-8 md:gap-10">
            <a
              href="/privacy"
              className="text-[13px] font-medium tracking-[-0.45px] text-black transition-opacity hover:opacity-60 md:text-[15px]"
            >
              Privacy Policy
            </a>
            <a
              href="/terms"
              className="text-[13px] font-medium tracking-[-0.45px] text-black transition-opacity hover:opacity-60 md:text-[15px]"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
